import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import useGetProfileData from '@libs/hooks/useGetProfileData';
import { AccountIcon, AutomationIcon, CashflowIcon, CircileCoinIcon, DeptIcon, GearIcon } from '@import/icons';
import { UserRole } from '@libs/@core/security/rolePermissions';
import { ACCOUNT_MANAGEMENT_URL, AGGREGRATE_CF_URL, CF_OVERVIEW_URL, CF_STATEMENT_URL, CF_TEMPLATE_URL, DEPT_MANAGEMENT_URL, MULTI_LANGUAGE_URL, SUPPLIER_MANAGEMENT_URL, SUPPLIER_BALANCE_URL, AP_OVERVIEW_URL, AR_OVERVIEW_URL, CUSTOMER_MANAGEMENT_URL, CUSTOMER_BALANCE_URL, PAYMENT_URL, DUNNING_LETTER_URL } from '@src/routes/url';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var useGetMenuList = function () {
    var t = useCustomTranslation();
    var data = useGetProfileData().data;
    var menuList = useMemo(function () {
        var _a;
        if (!data)
            return [];
        var role = data.role;
        var menu = [
            {
                id: 3,
                icon: _jsx(CashflowIcon, {}),
                text: t('L000049'),
                children: [
                    {
                        id: 3.1,
                        text: t('L000048'),
                        path: "".concat(CF_OVERVIEW_URL)
                    },
                    {
                        id: 3.2,
                        text: t('L000050'),
                        path: "".concat(CF_STATEMENT_URL)
                    },
                    {
                        id: 3.3,
                        text: t('L000051'),
                        path: "".concat(CF_TEMPLATE_URL)
                    },
                    {
                        id: 3.4,
                        text: t('L000052'),
                        path: "".concat(AGGREGRATE_CF_URL)
                    }
                ]
            }
        ];
        if (role === UserRole.FinancialOfficer) {
            menu = [
                {
                    id: 3,
                    icon: _jsx(CashflowIcon, {}),
                    text: t('L000049'),
                    children: [
                        {
                            id: 3.1,
                            text: t('L000048'),
                            path: "".concat(CF_OVERVIEW_URL)
                        },
                        {
                            id: 3.2,
                            text: t('L000050'),
                            path: "".concat(CF_STATEMENT_URL)
                        },
                        {
                            id: 3.3,
                            text: t('L000051'),
                            path: "".concat(CF_TEMPLATE_URL)
                        },
                        {
                            id: 3.4,
                            text: t('L000052'),
                            path: "".concat(AGGREGRATE_CF_URL)
                        }
                    ]
                },
                {
                    id: 4,
                    icon: _jsx(CircileCoinIcon, {}),
                    text: t('L000136'),
                    children: [
                        {
                            id: 4.1,
                            text: t('L000139'),
                            path: "".concat(AP_OVERVIEW_URL)
                        },
                        {
                            id: 4.2,
                            text: t('L000124'),
                            path: "".concat(SUPPLIER_MANAGEMENT_URL)
                        },
                        {
                            id: 4.3,
                            text: t('L000138'),
                            path: "".concat(SUPPLIER_BALANCE_URL)
                        }
                    ]
                },
                {
                    id: 5,
                    icon: _jsx(CircileCoinIcon, {}),
                    text: t('L000184'),
                    children: [
                        {
                            id: 5.1,
                            text: t('L000140'),
                            path: "".concat(AR_OVERVIEW_URL)
                        },
                        {
                            id: 5.2,
                            text: t('L000141'),
                            path: "".concat(CUSTOMER_MANAGEMENT_URL)
                        },
                        {
                            id: 5.3,
                            text: t('L000142'),
                            path: "".concat(CUSTOMER_BALANCE_URL)
                        }
                    ]
                },
                {
                    id: 6,
                    icon: _jsx(GearIcon, {}),
                    text: 'Automation',
                    children: [
                        {
                            id: 6.1,
                            text: 'Payment',
                            path: "".concat(PAYMENT_URL)
                        },
                        {
                            id: 6.2,
                            text: 'Dunning letter',
                            path: "".concat(DUNNING_LETTER_URL)
                        }
                    ]
                }
            ];
        }
        if (role === UserRole.SCFO) {
            menu = [
                // {
                //   id: 1,
                //   icon: <DashboardIcon />,
                //   text: t('L000053')
                // },
                {
                    id: 2,
                    icon: _jsx(CashflowIcon, {}),
                    text: t('L000049'),
                    children: [
                        {
                            id: 2.1,
                            text: t('L000048'),
                            path: "".concat(CF_OVERVIEW_URL)
                        },
                        {
                            id: 2.2,
                            text: t('L000050'),
                            path: "".concat(CF_STATEMENT_URL)
                        },
                        {
                            id: 2.3,
                            text: t('L000052'),
                            path: "".concat(AGGREGRATE_CF_URL)
                        }
                    ]
                },
                {
                    id: 4,
                    icon: _jsx(CircileCoinIcon, {}),
                    text: t('L000136'),
                    children: [
                        {
                            id: 4.1,
                            text: t('L000139'),
                            path: "".concat(AP_OVERVIEW_URL)
                        },
                        {
                            id: 4.2,
                            text: t('L000124'),
                            path: "".concat(SUPPLIER_MANAGEMENT_URL)
                        },
                        {
                            id: 4.3,
                            text: t('L000138'),
                            path: "".concat(SUPPLIER_BALANCE_URL)
                        }
                    ]
                },
                {
                    id: 5,
                    icon: _jsx(CircileCoinIcon, {}),
                    text: t('L000184'),
                    children: [
                        {
                            id: 5.1,
                            text: t('L000140'),
                            path: "".concat(AR_OVERVIEW_URL)
                        },
                        {
                            id: 5.2,
                            text: t('L000141'),
                            path: "".concat(CUSTOMER_MANAGEMENT_URL)
                        },
                        {
                            id: 5.3,
                            text: t('L000142'),
                            path: "".concat(CUSTOMER_BALANCE_URL)
                        }
                    ]
                },
                {
                    id: 6,
                    icon: _jsx(GearIcon, {}),
                    text: 'Automation',
                    children: [
                        {
                            id: 6.1,
                            text: 'Payment',
                            path: "".concat(PAYMENT_URL)
                        },
                        {
                            id: 6.2,
                            text: 'Dunning letter',
                            path: "".concat(DUNNING_LETTER_URL)
                        }
                    ]
                }
            ];
        }
        if (role === UserRole.FunctionalDepartment) {
            menu[0].children = (_a = menu[0].children) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.id === 3.2; });
        }
        if (role === UserRole.SuperAdmin) {
            menu = [
                {
                    id: 2,
                    icon: _jsx(AccountIcon, {}),
                    text: t('L000002'),
                    path: ACCOUNT_MANAGEMENT_URL
                },
                {
                    id: 4,
                    icon: _jsx(DeptIcon, {}),
                    text: t('L000054'),
                    path: DEPT_MANAGEMENT_URL
                },
                {
                    id: 5,
                    icon: _jsx(AutomationIcon, {}),
                    text: t('L000019'),
                    path: MULTI_LANGUAGE_URL
                }
            ];
        }
        return menu;
    }, [data, t]);
    return menuList;
};
export default useGetMenuList;
